<template>
  <div class="main-finance">
    <div class="cargo-finance-sum">
      <div style="width: 33.33%">
        <el-row class="row1-finance">
          <el-col :span="6">{{$lang('票数合计')}}</el-col>
          <el-col :span="6">{{$lang('签收票数')}}</el-col>
          <el-col :span="6">{{$lang('件数合计')}}</el-col>
          <el-col :span="6">{{$lang('总结算重量')}}</el-col>
        </el-row>
        <el-row class="row2-finance">
          <el-col :span="6">{{totalResult.deliveryCount || 0}}</el-col>
          <el-col :span="6">{{totalResult.signedCount || 0}}</el-col>
          <el-col :span="6">{{totalResult.deliveryNumber || 0}}</el-col>
          <el-col :span="6">{{totalResult.deliveryWeight || 0.00}}</el-col>
        </el-row>
      </div>
      <div class="separator"></div>
      <div style="width: 33.33%">
        <el-row style="margin-top: 25px">
          <el-col :span="8">{{$lang('合计包材费')}}</el-col>
          <el-col :span="8">{{$lang('合计其他费')}}</el-col>
          <el-col :span="8">{{$lang('合计入仓费')}}</el-col>
        </el-row>
        <el-row class="row2-finance">
          <el-col :span="8">{{totalResult.packageFee || 0.00}}</el-col>
          <el-col :span="8">{{totalResult.otherFee || 0.00}}</el-col>
          <el-col :span="8">{{totalResult.wareHouseFee || 0.00}}</el-col>
        </el-row>
        <el-row class="row2-finance">
          <el-col :span="12">{{$lang('保险费')}}</el-col>
          <el-col :span="12">{{$lang('回单费')}}</el-col>
        </el-row>
        <el-row class="row2-finance">
          <el-col :span="12">{{totalResult.premium || 0.00}}</el-col>
          <el-col :span="12">{{totalResult.receiptFee || 0.00}}</el-col>
        </el-row>
      </div>
      <div class="separator"></div>
      <div style="width: 33.33%">
        <el-row class="row1-finance">
          <el-col :span="6">{{$lang('折扣')}}</el-col>
          <el-col :span="6">{{$lang('折前总费用')}}</el-col>
          <el-col :span="6">{{$lang('折后总费用')}}</el-col>
          <el-col :span="6">{{$lang('应付总费用')}}</el-col>
        </el-row>
        <el-row class="row2-finance">
          <el-col :span="6">{{totalResult.discount || 0.00}}</el-col>
          <el-col :span="6">{{totalResult.freight || 0.00}}</el-col>
          <el-col :span="6">{{totalResult.afterDiscount || 0.00}}</el-col>
          <el-col :span="6">{{totalResult.totalFee || 0.00}}</el-col>
        </el-row>
      </div>
    </div>
    <div class="form-finance">
      <el-form :inline="true" :model="searchParam" class="demo-form-inline">
        <el-form-item prop="date"  :label="$lang('账单月份')">
          <el-date-picker
              :clearable="false"
              v-model="searchParam.date"
              type="monthrange"
              :range-separator="$lang('至')"
              :start-placeholder="$lang('开始日期')"
              :end-placeholder="$lang('结束日期')"
              class="commonSize"
              @change="selectDate"
              value-format="yyyy-MM"
              :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$lang('运单号')" prop="waybillNo" v-show="activeName ==='detail'">
          <base-input-tag
              v-model="searchParam.waybillNo"
              :placeholder="$lang('最多可查100条')"
              clearBtnVisible
              addTagOnBlur
              ref="orderNumberRef"
              class="cms-input-tag"
          >
          </base-input-tag>
        </el-form-item>
        <el-form-item style="display: flex;justify-content: flex-end;">
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="onSubmit">{{$lang('查询')}}</el-button>
          <el-button @click="reset" icon="el-icon-delete">{{$lang('清空')}}</el-button>
          <el-button @click="exportRecord" :loading="loading" icon="el-icon-download">{{$lang('导出')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-finance">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$lang('汇总')" name="sum">
          <JmsTableScroll
              ref="sumTable"
              class="tableClass"
              :option="sumListOpt"
              :data="sumTableData"
              :page="page"
              :table-loading="loading"
              @size-change="sizeChange"
              @current-change="currentChange"
          >
          </JmsTableScroll>
        </el-tab-pane>
        <el-tab-pane :label="$lang('明细')" name="detail">
          <JmsTableScroll
              :option="detailListOpt"
              :data="detailTableData"
              :page="page"
              :table-loading="loading"
              @size-change="sizeChange"
              @current-change="currentChange"
          >
          </JmsTableScroll>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { commonFun } from '@utils/common'
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import { pageFinanceSum, pageFinanceDetail, exportAsync } from '@api/module/customer'
import { RESPONSE_SUCCESS } from '@constants'

export default {
  name: 'Finance',
  components: {
    JmsTableScroll,
  },
  props: {
    tabPosition: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      totalResult: {
        deliveryCount: 0,
        signedCount: 0,
        deliveryNumber: 0,
        deliveryWeight: 0.00,
        premium: 0.00,
        packageFee: 0.00,
        otherFee: 0.00,
        wareHouseFee: 0.00,
        receiptFee: 0.00,
        freight: 0.00,
        afterDiscount: 0.00,
        discount: 0.00,
        totalFee: 0.00,
      },
      sumTableData: [],
      detailTableData: [],
      activeName: 'sum',
      page: {
        // 分页配置
        current: 1,
        size: 50,
        total: 0,
        pageSizes: [50, 100, 200, 500],
      },
      searchParam: {
        date: [],
      },
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          const space = 365 * 24 * 3600 * 1000
          const minTime = new Date().getTime() - space
          const maxTime = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
          return time.getTime() < minTime || time.getTime() > maxTime
        },
      },
    }
  },
  watch: {
    tabPosition(val) {
      if (val && this.$refs.sumTable) {
        this.$refs.sumTable.$refs.table.doLayout()
      }
    },
  },
  methods: {
    validateParam() {
      console.log(this.searchParam)
      const { beginDate, endDate } = this.searchParam
      const space = 3 * 31 * 24 * 3600 * 1000
      const startTimeLong = new Date(beginDate + '-01').getTime()
      const endTimeLong = new Date(endDate + '-01').getTime()
      if (endTimeLong - startTimeLong > space) {
        return this.$message.error(this.$lang('开始时间与结束时间之差不能大于3个月'))
      }
      // 处理运单编号
      if (this.searchParam.waybillNo && this.searchParam.waybillNo.length !== 0) {
        if (this.searchParam.waybillNo.length > 100) {
          return this.$message.warning(this.$lang('单号请勿超过100条'))
        }
      }
    },
    async exportRecord() {
      if (this.validateParam()) {
        return
      }
      this.loading = true
      if (this.activeName === 'sum') {
        this.searchParam.fileCode = '3'
      }
      if (this.activeName === 'detail') {
        this.searchParam.fileCode = '4'
      }
      const { code, data, msg } = await exportAsync(this.searchParam)
      this.loading = false
      if (code === RESPONSE_SUCCESS && data) {
        this.$message.success(this.$lang('导出成功，请到下载中心查看'))
      } else {
        return this.$message.error(this.$lang(msg))
      }
    },
    async onSubmit() {
      if (this.validateParam()) {
        return
      }
      this.loading = true
      this.searchParam.current = this.page.current
      this.searchParam.size = this.page.size
      if (this.activeName === 'sum') {
        const { code, data, msg } = await pageFinanceSum(this.searchParam)
        this.loading = false
        if (code === RESPONSE_SUCCESS) {
          this.sumTableData = data.records
          this.totalResult = data.totalResult
          this.page.current = data.current
          this.page.total = data.total
          this.$nextTick(() => {
            this.$refs.sumTable.$refs.table.doLayout()
          })
        } else {
          return this.$message.error(this.$lang(msg))
        }
      }
      if (this.activeName === 'detail') {
        const { code, data, msg } = await pageFinanceDetail(this.searchParam)
        this.loading = false
        if (code === RESPONSE_SUCCESS) {
          this.detailTableData = data.records
          if (this.detailTableData && this.detailTableData.length > 0) {
            for (let i = 0; i < this.detailTableData.length; i++) {
              this.detailTableData[i].isSign = this.$lang(this.detailTableData[i].isSign)
            }
          }

          this.page.current = data.current
          this.page.total = data.total
        } else {
          this.$message.error(this.$lang(msg))
        }
      }
    },
    // 选择日期
    selectDate() {
      if (this.searchParam.date) {
        const [start = '', end = ''] = this.searchParam.date
        this.searchParam.beginDate = start
        this.searchParam.endDate = end
      }
    },
    setDefaultDate() {
      const today = new Date()
      // 当前月份
      const currentMonth = commonFun.formatMonth(today.getMonth() + 1, today.getFullYear())
      // 上个月的日期
      const lastMonthDate = new Date(today.getFullYear(), today.getMonth(), 0)
      const lastMonth = commonFun.formatMonth(lastMonthDate.getMonth() + 1, lastMonthDate.getFullYear())
      console.log(lastMonth, currentMonth)
      this.searchParam.date = [lastMonth, currentMonth]
      this.selectDate()
    },
    reset() {
      this.setDefaultDate()
      this.searchParam.waybillNo = []
    },
    // 选择分页条数
    sizeChange(val) {
      this.page.current = 1
      this.page.size = val
      this.onSubmit()
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.onSubmit()
    },
    handleClick() {
      console.log(this.activeName)
      this.onSubmit()
    },
  },
  created() {
    this.setDefaultDate()
    this.onSubmit()
  },
  computed: {
    sumListOpt() {
      return {
        tableHeight: '400',
        border: true,
        selection: false,
        menu: false,
        menuWidth: 150,
        rowKey: '$index',
        viewBtn: false,
        column: [
          {
            label: '账单月份',
            prop: 'billMonth',
          },
          {
            label: '票数合计',
            prop: 'deliveryCount',
          },
          {
            label: '签收票数',
            prop: 'signedCount',
          },
          {
            label: '件数合计',
            prop: 'deliveryNumber',
          },
          {
            label: '总结算重量',
            prop: 'deliveryWeight',
          },
          {
            label: '保险费合计',
            prop: 'premium',
          },
          {
            label: '包材费合计',
            prop: 'packageFee',
          },
          {
            label: '其他费合计',
            prop: 'otherFee',
          },
          {
            label: '入仓费',
            prop: 'wareHouseFee',
          },
          {
            label: '回单费',
            prop: 'receiptFee',
          },
          {
            label: '折扣',
            prop: 'discount',
          },
          {
            label: '折前总费用',
            prop: 'freight',
          },
          {
            label: '折后总费用',
            prop: 'afterDiscount',
          },
          {
            label: '应付总费用',
            prop: 'totalFee',
          },
        ],
      }
    },
    detailListOpt() {
      return {
        tableHeight: '400',
        border: true,
        selection: false,
        menu: false,
        menuWidth: 150,
        rowKey: '$index',
        viewBtn: false,
        column: [
          {
            label: '账单月份',
            prop: 'billMonth',
          },
          {
            label: '客户名称',
            prop: 'customerName',
          },
          {
            label: '运单号',
            prop: 'waybillNo',
          },
          {
            label: '是否签收',
            prop: 'isSign',
          },
          {
            label: '件数',
            prop: 'packageNumber',
          },
          {
            label: '结算重量',
            prop: 'settWeight',
          },
          {
            label: '保价费',
            prop: 'insuredFee',
          },
          {
            label: '包材费',
            prop: 'packageCost',
          },
          {
            label: '其他费',
            prop: 'otherFee',
          },
          {
            label: '入仓费',
            prop: 'wareHouseFee',
          },
          {
            label: '回单费',
            prop: 'receiptFee',
          },
          {
            label: '折前总费用',
            prop: 'totalFreight',
          },
          {
            label: '折后总费用',
            prop: 'afterTaxFreight',
          },
          {
            label: '应付总费用',
            prop: 'totalFee',
          },
          {
            label: '寄件日期',
            prop: 'deliveryTime',
          },
          {
            label: '寄件人名称',
            prop: 'senderName',
          },
          {
            label: '寄件人电话',
            prop: 'senderMobilePhone',
          },
          {
            label: '寄件省份',
            prop: 'senderProvinceName',
          },
          {
            label: '寄件城市',
            prop: 'senderCityName',
          },
          {
            label: '寄件区域',
            prop: 'senderAreaName',
          },
          {
            label: '寄件详细地址',
            prop: 'senderDetailedAddress',
          },
          {
            label: '收件人姓名',
            prop: 'receiverName',
          },
          {
            label: '收件人电话',
            prop: 'receiverMobilePhone',
          },
          {
            label: '收件省份',
            prop: 'receiverProvinceName',
          },
          {
            label: '收件城市',
            prop: 'receiverCityName',
          },
          {
            label: '收件区域',
            prop: 'receiverAreaName',
          },
          {
            label: '收件详细地址',
            prop: 'receiverDetailedAddress',
          },
        ],
      }
    },
  },
}
</script>

<style scoped>

.main-finance{
  font-weight: 500;
  color: #666;
}

.row1-finance{
  margin-top: 50px;
}
.row2-finance{
  margin-top: 10px;
}

.cargo-finance-sum{
  border: 1px solid black;
  border-radius: 20px;
  width: 90%;
  height: 150px;
  text-align: center;
  margin-left: 50px;
  display: flex;
}
.separator {
  margin-top: 20px;
  width: 1px;
  background-color: #000;
  height: 100px;
}
.form-finance{
  margin-left: 50px;
  margin-top: 20px;
}
.table-finance{
  margin-left: 50px;
}
.order-number-select >>> .el-input{
  width: 90px !important;
}
</style>
